"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefinitionsHelpers = void 0;
var core_1 = require("@newfront-insurance/core");
var next_api_swr_1 = require("@newfront-insurance/next-api-swr");
var react_1 = require("react");
var routes_1 = require("../bff/routes");
var provider_1 = require("../provider");
function useDefinitions(params, config) {
    if (params === void 0) { params = {}; }
    var basePath = react_1.useContext(provider_1.CoverageApiContext).basePath;
    return next_api_swr_1.useNextApiSubscription(routes_1.routes.definitions.getUrl(params, basePath), config);
}
function useDefinitionsHelpers(params, config) {
    if (params === void 0) { params = {}; }
    var _a = useDefinitions(params, config), data = _a.data, error = _a.error;
    var locDefinitionsArray = react_1.useMemo(function () { var _a; return (_a = data === null || data === void 0 ? void 0 : data.linesOfCoverage) !== null && _a !== void 0 ? _a : []; }, [data]);
    var policyTypeDefinitions = react_1.useMemo(function () { var _a; return (_a = data === null || data === void 0 ? void 0 : data.policyTypes) !== null && _a !== void 0 ? _a : {}; }, [data]);
    var lineOfCoverageTypes = react_1.useMemo(function () { return locDefinitionsArray.map(function (_a) {
        var id = _a.id;
        return id;
    }); }, [locDefinitionsArray]);
    var lineOfCoverageTypeDefinitions = react_1.useMemo(function () { return core_1.toRecord(locDefinitionsArray || [], function (_a) {
        var id = _a.id;
        return id;
    }); }, [locDefinitionsArray]);
    var policyTypes = react_1.useMemo(function () { return Object.keys(policyTypeDefinitions); }, [policyTypeDefinitions]);
    var renderPolicyType = react_1.useCallback(function (type) { var _a; return ((_a = policyTypeDefinitions[type]) === null || _a === void 0 ? void 0 : _a.readableName) || type; }, [policyTypeDefinitions]);
    var renderLineOfCoverageType = react_1.useCallback(function (type) { var _a; return ((_a = lineOfCoverageTypeDefinitions[type]) === null || _a === void 0 ? void 0 : _a.readableName) || type; }, [lineOfCoverageTypeDefinitions]);
    return {
        loading: !data && !error,
        error: error,
        lineOfCoverageTypes: lineOfCoverageTypes,
        lineOfCoverageTypeDefinitions: lineOfCoverageTypeDefinitions,
        policyTypes: policyTypes,
        policyTypeDefinitions: policyTypeDefinitions,
        renderPolicyType: renderPolicyType,
        renderLineOfCoverageType: renderLineOfCoverageType,
    };
}
exports.useDefinitionsHelpers = useDefinitionsHelpers;
